import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { CmpsAccordionItemComponent } from '@cmps/ng-uikit';

import { CaResult } from '../../../core';

@Component({
    selector: 'cmps-ca-evaluation-result-main',
    templateUrl: './main.component.html',
    host: {
        class: 'cmps-ca-evaluation-result-main',
    },
})
export class MainComponent {
    @ViewChildren(CmpsAccordionItemComponent)
    private readonly _items: QueryList<CmpsAccordionItemComponent>;

    @Input() get caResult(): CaResult {
        return this._caResult;
    }

    set caResult(value: CaResult) {
        this._caResult = value;
    }

    @Input() get collapsed(): boolean {
        return this._collapsed;
    }

    set collapsed(value: boolean) {
        const manual = this._collapsed === value;
        this._collapsed = value;
        if (manual) {
            // TODO fix CmpsAccordionItemComponent
            this._items?.forEach((e) => (value ? e.close() : e.open()));
        }
    }

    @Input() get collapsedProTips(): boolean {
        return false;
    }

    set collapsedProTips(_: boolean) {}

    /** @private */ _caResult: CaResult;
    /** @private */ _collapsed: boolean;
}
